import { render, staticRenderFns } from "./PolicyNews.vue?vue&type=template&id=0452f0af&scoped=true&"
import script from "./PolicyNews.vue?vue&type=script&lang=js&"
export * from "./PolicyNews.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=0452f0af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452f0af",
  null
  
)

export default component.exports